import { createApiClient } from 'Network/ApiClient';

export const ServiceCodeAxiosInstance = createApiClient('ServiceCode/');
